import { render, staticRenderFns } from "./orderBatDeliver.vue?vue&type=template&id=a1990994&scoped=true"
import script from "./orderBatDeliver.vue?vue&type=script&lang=js"
export * from "./orderBatDeliver.vue?vue&type=script&lang=js"
import style0 from "./orderBatDeliver.vue?vue&type=style&index=0&id=a1990994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1990994",
  null
  
)

export default component.exports